export const apiUrls = {
  auth: {
    base: "/api/Auth",
    login: "/api/Auth/login",
  },
  category: {
    base: "/api/Category",
    active: "/api/Category/ActivateCategory",
    inactive: "/api/Category/InactiveCategory",
    moveUp: "/api/Category/MoveUpCategory",
    moveDown: "/api/Category/MoveDownCategory",
    deleteNode: (id: number | null) => `/api/Category/${id}`,
  },
  country: {
    base: "/api/Country",
    getRegions: "/api/Country/GetAllRegions",
  },
  form: {
    base: "/api/Form",
    EditForm: "/api/Form/EditForm",
    getForms: (id: number | null) => `/api/Form?countryId=${id}`,
    getFormById: (id: number | null) => `/api/Form/${id}`,
    deleteForm: `/api/Form/DeleteForm`,
    getFormContent: "/api/Form/GetFormContent",
    getCategories: "/api/Form/GetAllFormCategory",
    applyReview: "/api/Form/ApplyReviewDate",
  },
  uploadFile: {
    base: "/api/PublisherWizard/UploadExcelFile",
  },
  regulation: {
    base: "/api/Regulation",
    EditRegulation: "/api/Regulation/EditRegulation",
    getRegulations: (id: number | null) => `/api/Regulation?countryId=${id}`,
    getRegulationById: (id: number | null) => `/api/Regulation/${id}`,
    deleteRegulation: `api/Regulation/DeleteRegulation`,
    getRegulationContent: "/api/Regulation/GetRegulationContent",
    getCategories: "/api/Regulation/GetRegulationCategories",
    applyReview: "/api/Regulation/ApplyReviewDate",
  },
  newsaggregator: {
    base: "/api/NewsAggretor",
    aggregatingnews: "/api/NewsAggregator/AggregatingNews",
  },
  mliData: {
    upload: "/api/MLIData/ImportMliDataFromExcel",
  },
  p2NewsCountryMap: {
    getNewsByCountry: "/api/P2NewsCountryMap/GetNewsByCountry",
    saveMapping: "/api/P2NewsCountryMap/SaveMapping",
  },
};
